/* SHK Works theme JS ─ v2.2
   Architecture: everything is either (a) idempotent init functions re-run on
   Shopify editor section loads, or (b) document-level delegated handlers that
   survive any section re-render. */
(function () {
  'use strict';

  document.documentElement.classList.add('js');

  var routes = (window.SHK && window.SHK.routes) || {
    cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', cartUpdate: '/cart/update', root: '/'
  };
  if (!routes.cartUpdate) routes.cartUpdate = '/cart/update';

  /* In the theme editor, sections re-render on every setting change.
     Scroll-reveal must never hide freshly rendered content there. */
  var DESIGN = !!(window.Shopify && window.Shopify.designMode);

  /* ================= CREATOR CODE SYSTEM =================
     Three capture paths, one remembered code (localStorage):
     1. Referral links  — any page + ?ref=CODE (or ?creator=CODE)
     2. Manual entry    — cart drawer, cart page, product page, design popup
     3. Product page    — properties[Creator Code] rides inside the product
        form, so even dynamic checkout (Buy Now) buttons that skip the cart
        carry the code onto the order as a line item property. */
  function storedCreatorCode() {
    try { return (localStorage.getItem('shkCreatorCode') || '').trim(); } catch (err) { return ''; }
  }
  function rememberCreatorCode(code) {
    try { localStorage.setItem('shkCreatorCode', code); } catch (err) {}
  }
  function prefillCreatorInputs() {
    var code = storedCreatorCode();
    if (!code) return;
    document.querySelectorAll('[data-creator-input], input[name="contact[Creator Code]"]').forEach(function (input) {
      if (!input.value) {
        input.value = code;
        /* if it lives in the collapsed product-page disclosure, open it so
           the shopper can see their code is attached */
        var pdp = input.closest('[data-creator-pdp]');
        if (pdp) pdp.setAttribute('open', '');
      }
    });
  }

  /* Referral links: capture the code, then route once through Shopify's
     /discount/ endpoint, which sets a checkout-wide discount cookie. That
     cookie applies on EVERY path to checkout — including product-page Buy
     Now buttons that never touch the cart. Redirects at most once per code
     per session, and never inside the theme editor. */
  (function () {
    if (DESIGN) return;
    var params = new URLSearchParams(window.location.search);
    var code = (params.get('ref') || params.get('creator') || '').trim();
    if (!code) return;
    rememberCreatorCode(code);
    var marker = null;
    try { marker = sessionStorage.getItem('shkRefApplied'); } catch (err) {}
    if (marker === code) return;
    try { sessionStorage.setItem('shkRefApplied', code); } catch (err) {}
    params.delete('ref');
    params.delete('creator');
    var clean = window.location.pathname + (params.toString() ? '?' + params.toString() : '') + window.location.hash;
    window.location.replace('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(clean));
  })();

  /* Manual entry anywhere becomes the remembered code */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-creator-input], input[name="contact[Creator Code]"]');
    if (!input) return;
    var value = input.value.trim();
    if (value) rememberCreatorCode(value);
  });

  /* The product-page property input only carries a name while it has a
     value, so no submission path (including Buy Now) sends a blank
     "Creator Code" property on orders where no code was entered. */
  function syncPdpPropertyName() {
    document.querySelectorAll('[data-creator-pdp] [data-creator-input]').forEach(function (input) {
      if (input.value.trim()) input.setAttribute('name', 'properties[Creator Code]');
      else input.removeAttribute('name');
    });
  }
  document.addEventListener('input', function (e) {
    if (e.target.closest('[data-creator-pdp] [data-creator-input]')) syncPdpPropertyName();
  });

  /* ================= MOBILE NAV (hamburger) ================= */
  function closeNav() {
    var nav = document.querySelector('.site-nav');
    if (!nav || !nav.classList.contains('is-open')) return;
    nav.classList.remove('is-open');
    var btn = nav.querySelector('[data-nav-toggle].nav-burger');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-nav-toggle]');
    if (toggle) {
      var nav = toggle.closest('.site-nav');
      if (!nav) return;
      var isOpen = nav.classList.toggle('is-open');
      var btn = nav.querySelector('.nav-burger');
      if (btn) btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      return;
    }
    /* clicking a nav link closes the panel (same-page anchors like #contact) */
    if (e.target.closest('[data-nav-links] a')) closeNav();
  });

  /* ================= DISMISSIBLE ANNOUNCEMENT BAR =================
     Session-scoped: dismissing hides it for the rest of this browser
     session only, and it comes back if the message text changes. */
  (function () {
    var bar = document.querySelector('[data-announce]');
    if (!bar) return;
    var textEl = bar.querySelector('.announce-text');
    var key = 'shkAnnounceDismissed:' + (textEl ? textEl.textContent.trim().slice(0, 60) : '');
    try {
      if (sessionStorage.getItem(key) === '1') { bar.remove(); return; }
    } catch (err) {}
    bar.addEventListener('click', function (e) {
      if (!e.target.closest('[data-announce-close]')) return;
      bar.remove();
      try { sessionStorage.setItem(key, '1'); } catch (err) {}
    });
  })();

  /* After a referral landing, confirm visibly — once per session */
  (function () {
    var code = storedCreatorCode();
    if (!code) return;
    var applied = null, shown = null;
    try {
      applied = sessionStorage.getItem('shkRefApplied');
      shown = sessionStorage.getItem('shkRefToastShown');
    } catch (err) { return; }
    if (applied !== code || shown === code) return;
    try { sessionStorage.setItem('shkRefToastShown', code); } catch (err) {}
    var t = document.createElement('div');
    t.className = 'toast';
    t.setAttribute('aria-live', 'polite');
    t.innerHTML = '<span class="toast-stamp">紹</span><div>クリエイターコード適用<small>CREATOR CODE ' + code.replace(/[<>&"]/g, '') + ' SAVED</small></div>';
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('show'); });
    setTimeout(function () { t.classList.remove('show'); }, 3400);
    setTimeout(function () { t.remove(); }, 4200);
  })();

  /* ================= SCROLL REVEAL ================= */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('on');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.12 });

  function reveal(scope) {
    (scope || document).querySelectorAll('.rv:not(.on)').forEach(function (el) {
      if (DESIGN) {
        el.classList.add('on');
      } else {
        io.observe(el);
      }
    });
  }

  /* ================= IDEMPOTENT SECTION INITS ================= */
  function initTicker(scope) {
    (scope || document).querySelectorAll('[data-ticker]:not([data-inited])').forEach(function (t) {
      t.dataset.inited = '1';
      t.innerHTML = t.innerHTML.repeat(4);
    });
  }

  function initNews(scope) {
    (scope || document).querySelectorAll('[data-news-track]:not([data-inited])').forEach(function (n) {
      if (!n.children.length) return;
      n.dataset.inited = '1';
      n.innerHTML = n.innerHTML + n.innerHTML; /* duplicate for seamless loop */
    });
  }

  function initTagline(scope) {
    (scope || document).querySelectorAll('[data-tagline]').forEach(function (sec) {
      sec.querySelectorAll('.tag-line .tw').forEach(function (w, i) {
        w.style.animationDelay = (i * 0.14) + 's';
      });
      sec.querySelectorAll('.tag-attr .tw').forEach(function (w, i) {
        w.style.animationDelay = (0.42 + i * 0.14) + 's';
      });
    });
  }

  function initStickyBuy(scope) {
    (scope || document).querySelectorAll('[data-sticky-buy]:not([data-inited])').forEach(function (bar) {
      bar.dataset.inited = '1';
      var buyRow = document.querySelector('.buy-row');
      if (!buyRow) return;
      var buyIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('show', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      }, { threshold: 0 });
      buyIO.observe(buyRow);
    });
  }

  function initRelated(scope) {
    (scope || document).querySelectorAll('[data-related]:not([data-inited])').forEach(function (related) {
      related.dataset.inited = '1';
      if (!related.dataset.url) return;
      fetch(related.dataset.url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-related]');
          if (fresh && fresh.innerHTML.trim().length) {
            related.innerHTML = fresh.innerHTML;
            reveal(related);
          } else if (!DESIGN) {
            related.remove();
          }
        })
        .catch(function () { if (!DESIGN) related.remove(); });
    });
  }

  function initAddressForms(scope) {
    (scope || document).querySelectorAll('[data-address-country]:not([data-inited])').forEach(function (countrySel) {
      countrySel.dataset.inited = '1';
      var wrap = countrySel.closest('form') || document;
      var provinceSel = wrap.querySelector('[data-address-province]');
      function syncProvinces() {
        if (!provinceSel) return;
        var opt = countrySel.selectedOptions[0];
        var raw = opt ? opt.getAttribute('data-provinces') : null;
        provinceSel.innerHTML = '';
        var provinces = [];
        try { provinces = raw ? JSON.parse(raw) : []; } catch (err) { provinces = []; }
        if (!provinces.length) {
          provinceSel.parentElement.style.display = 'none';
          return;
        }
        provinceSel.parentElement.style.display = '';
        provinces.forEach(function (p) {
          var o = document.createElement('option');
          o.value = p[0];
          o.textContent = p[1];
          provinceSel.appendChild(o);
        });
        if (provinceSel.dataset.default) provinceSel.value = provinceSel.dataset.default;
      }
      if (countrySel.dataset.default) countrySel.value = countrySel.dataset.default;
      countrySel.addEventListener('change', syncProvinces);
      syncProvinces();
    });
  }

  function initSection(scope) {
    initTicker(scope);
    initNews(scope);
    initTagline(scope);
    initStickyBuy(scope);
    initRelated(scope);
    initAddressForms(scope);
    reveal(scope);
  }

  /* Initial page load */
  initSection(document);

  /* Theme editor: re-init whatever section was re-rendered or added */
  document.addEventListener('shopify:section:load', function (e) {
    initSection(e.target);
  });
  /* Reordering re-attaches DOM nodes; re-check reveals so nothing stays hidden */
  document.addEventListener('shopify:section:reorder', function () {
    reveal(document);
  });

  /* ================= GALLERY FILTERS (delegated) ================= */
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-filters] .chip');
    if (!chip) return;
    var filters = chip.closest('[data-filters]');
    var root = filters.closest('.shopify-section') || document;
    var grid = root.querySelector('[data-gallery-grid]');
    if (!grid) return;
    filters.querySelectorAll('.chip').forEach(function (c) { c.classList.remove('sel'); });
    chip.classList.add('sel');
    var f = chip.dataset.f;
    grid.querySelectorAll('.gal-item').forEach(function (g) {
      var match = f === 'all' || g.dataset.cat === f;
      g.style.display = match ? '' : 'none';
      if (match) {
        g.classList.remove('on');
        void g.offsetWidth;
        g.classList.add('on');
      }
    });
  });

  /* ================= CONTACT NAV LINK (delegated) ================= */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-scroll-contact]');
    if (!link) return;
    var target = document.getElementById('contact');
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth' });
    }
  });

  /* ================= GENERIC TOGGLES ================= */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-toggle-target]');
    if (!t) return;
    e.preventDefault();
    var el = document.querySelector(t.dataset.toggleTarget);
    if (el) el.style.display = el.style.display === 'none' ? '' : 'none';
  });

  /* Login / recover panel switch */
  document.addEventListener('click', function (e) {
    var recover = e.target.closest('[data-show-recover]');
    var login = e.target.closest('[data-show-login]');
    if (!recover && !login) return;
    e.preventDefault();
    var lp = document.getElementById('LoginPanel');
    var rp = document.getElementById('RecoverPanel');
    if (lp && rp) {
      lp.style.display = recover ? 'none' : '';
      rp.style.display = recover ? '' : 'none';
    }
  });
  if (window.location.hash === '#recover') {
    var rBtn = document.querySelector('[data-show-recover]');
    if (rBtn) rBtn.click();
  }

  /* ================= DESIGN MODAL (delegated — editor & re-render safe) =================
     Panes: "pick" (choose your path), one pane per form track ("livery",
     "stickers"), and "done". Each track is its own contact form with its
     own list of rendered steps; empty steps are never rendered, so the
     step list comes straight from the DOM. */
  var modalTrack = null;   /* null = picker, otherwise 'livery' | 'stickers' */
  var modalIdx = 0;        /* index into the current track's steps */
  var trackImgs = {};      /* track -> [{ name, type, dataUrl }] */
  var TRACK_KEY = 'shkDesignTrack';

  function modalEl() { return document.querySelector('[data-design-overlay]'); }
  function trackEl(overlay, t) { return overlay ? overlay.querySelector('[data-track="' + t + '"]') : null; }
  function hasPicker(overlay) { return !!(overlay && overlay.querySelector('[data-track-pick]')); }
  function firstTrack(overlay) {
    var t = overlay.querySelector('[data-track]');
    return t ? t.dataset.track : null;
  }
  function trackSteps(tEl) { return tEl ? Array.prototype.slice.call(tEl.querySelectorAll('.q-step')) : []; }
  function imgsFor(t) { return trackImgs[t] || (trackImgs[t] = []); }
  function rememberTrack(t) { try { sessionStorage.setItem(TRACK_KEY, t); } catch (err) {} }
  function recallTrack() { try { return sessionStorage.getItem(TRACK_KEY) || ''; } catch (err) { return ''; } }
  function forgetTrack() { try { sessionStorage.removeItem(TRACK_KEY); } catch (err) {} }

  function showPane(overlay, name) {
    overlay.querySelectorAll('[data-pane]').forEach(function (p) {
      p.classList.toggle('cur', p.dataset.pane === name);
    });
    var nav = overlay.querySelector('[data-modal-nav]');
    if (nav) nav.style.display = (name === 'pick' || name === 'done') ? 'none' : 'flex';
    var body = overlay.querySelector('.modal-body');
    if (body && body.parentNode) body.parentNode.scrollTop = 0;
  }

  function showPicker() {
    var overlay = modalEl();
    if (!overlay) return;
    if (!hasPicker(overlay)) { goTrack(firstTrack(overlay), 0); return; }
    modalTrack = null;
    modalIdx = 0;
    showPane(overlay, 'pick');
  }

  function showDone() {
    var overlay = modalEl();
    if (!overlay) return;
    modalIdx = 'done';
    showPane(overlay, 'done');
  }

  function goTrack(t, i) {
    var overlay = modalEl();
    var tEl = trackEl(overlay, t);
    if (!tEl) { if (overlay && t !== firstTrack(overlay)) goTrack(firstTrack(overlay), 0); return; }
    modalTrack = t;
    var steps = trackSteps(tEl);
    if (i === 'last') i = steps.length - 1;
    i = Math.max(0, Math.min(+i || 0, steps.length - 1));
    modalIdx = i;
    showPane(overlay, t);
    steps.forEach(function (s, k) { s.classList.toggle('cur', k === i); });
    tEl.querySelectorAll('.step-dot').forEach(function (d, k) { d.classList.toggle('done', k <= i); });
    var back = overlay.querySelector('[data-back]');
    var next = overlay.querySelector('[data-next]');
    if (back) back.style.visibility = (i > 0 || hasPicker(overlay)) ? 'visible' : 'hidden';
    if (next) {
      next.disabled = false;
      next.innerHTML = i === steps.length - 1 ? 'SUBMIT' : 'NEXT';
    }
    tEl.querySelectorAll('[data-form-error],[data-phone-error],[data-img-error]').forEach(function (el) {
      el.classList.remove('show');
    });
  }

  /* target: undefined/'' → picker, 'done', or a track name */
  function openModal(target) {
    var overlay = modalEl();
    if (!overlay) return;
    overlay.classList.remove('open');
    void overlay.offsetWidth; /* restart swoop / skid / screech */
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    if (target === 'done') showDone();
    else if (target && trackEl(overlay, target)) goTrack(target, 0);
    else showPicker();
  }
  function closeModal() {
    var overlay = modalEl();
    if (!overlay) return;
    overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  function collectSelections(scope) {
    scope.querySelectorAll('[data-field]').forEach(function (input) {
      var group = scope.querySelector('[data-q="' + input.dataset.field + '"]');
      if (!group) return;
      var values = [];
      group.querySelectorAll('.sel').forEach(function (el) {
        values.push(el.dataset.c || el.textContent.trim());
      });
      input.value = values.join(', ');
    });
    scope.querySelectorAll('[data-check-value]').forEach(function (hidden) {
      var box = scope.querySelector('[data-check="' + hidden.dataset.checkValue + '"]');
      hidden.value = box && box.checked ? hidden.dataset.yes : hidden.dataset.no;
    });
  }

  function payloadFromForm(form) {
    var payload = {};
    new FormData(form).forEach(function (v, k) {
      var m = k.match(/^contact\[(.+)\]$/);
      if (m && String(v).trim()) payload[m[1]] = v;
    });
    return payload;
  }

  /* Sends the inquiry to the Google Sheet webhook.
     Apps Script web apps respond via a redirect that browsers won't expose
     cross-origin, so `mode:'no-cors'` is required — which means we can
     NEVER read back a real success/failure signal from Google. Given that
     hard limit, this function is built to fail safe instead of fail silent:

     - `keepalive:true` (used whenever the body is small enough — no
       images) tells the browser to finish sending the request even if the
       page navigates away right after. This is the fix for the main
       failure mode: previously, a slow connection would hit a timeout,
       the caller would navigate to the Shopify contact-form receipt page,
       and the browser would abort the still-in-flight request, silently
       losing the sheet row. Chrome enforces a ~64KB cap on keepalive
       bodies, so it can't be used once inspiration images are attached.
     - Without keepalive (image submissions), the caller must not navigate
       until this promise settles, so the timeout is generous (30s) to
       give Apps Script time to also push each image to Drive.
     - Because we can't see the real result, we return a `state` the
       caller can log into a hidden form field, so a human can tell from
       the backup email alone whether a given submission's sheet delivery
       is uncertain and worth double-checking: 'sent' (request completed
       normally — most likely delivered), 'blocked' (fetch threw
       synchronously, e.g. an ad blocker or DNS failure — did not reach
       Google), or 'timeout' (still in flight when we gave up waiting —
       may or may not have landed). */
  function postToSheet(url, payload, opts) {
    opts = opts || {};
    var timeoutMs = opts.timeoutMs || 30000;
    var useKeepalive = !!opts.keepalive;
    var result = { state: 'pending' };

    var fetchOpts = {
      method: 'POST',
      mode: 'no-cors',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify(payload)
    };
    if (useKeepalive) fetchOpts.keepalive = true;

    var req;
    try {
      req = fetch(url, fetchOpts).then(function () {
        result.state = 'sent';
      }).catch(function () {
        result.state = 'blocked';
      });
    } catch (err) {
      /* Synchronous throw: e.g. keepalive body over the browser's cap. */
      result.state = 'blocked';
      return Promise.resolve(result);
    }

    if (useKeepalive) {
      /* Handed off to the browser; safe to report success right away and
         let the caller move on without waiting on a slow connection. */
      result.state = 'sent';
      return Promise.resolve(result);
    }

    var timeout = new Promise(function (resolve) {
      setTimeout(function () {
        if (result.state === 'pending') result.state = 'timeout';
        resolve();
      }, timeoutMs);
    });
    return Promise.race([req, timeout]).then(function () { return result; });
  }

  /* While a non-keepalive sheet request is in flight, warn the customer
     before they close the tab or navigate away — that's the one thing
     that can still cut the request off, and a single "hold on" prompt is
     far better than a silently lost commission. */
  function warnBeforeUnload(e) {
    e.preventDefault();
    e.returnValue = '';
    return '';
  }

  /* ---------- Inspiration / reference image uploads (per track) ---------- */
  function processImageFile(file) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      var objUrl = URL.createObjectURL(file);
      img.onload = function () {
        try {
          var MAX = 1600;
          var scale = Math.min(1, MAX / Math.max(img.naturalWidth, img.naturalHeight));
          var canvas = document.createElement('canvas');
          canvas.width = Math.round(img.naturalWidth * scale);
          canvas.height = Math.round(img.naturalHeight * scale);
          canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
          URL.revokeObjectURL(objUrl);
          resolve({
            name: file.name.replace(/\.[^.]+$/, '') + '.jpg',
            type: 'image/jpeg',
            dataUrl: canvas.toDataURL('image/jpeg', 0.8)
          });
        } catch (err) { reject(err); }
      };
      img.onerror = function () {
        /* Format the browser can't decode (e.g. some HEIC) — send original if small enough */
        URL.revokeObjectURL(objUrl);
        if (file.size > 6 * 1024 * 1024) { reject(new Error('too large')); return; }
        var reader = new FileReader();
        reader.onload = function () {
          resolve({ name: file.name, type: file.type || 'image/jpeg', dataUrl: reader.result });
        };
        reader.onerror = function () { reject(new Error('read failed')); };
        reader.readAsDataURL(file);
      };
      img.src = objUrl;
    });
  }

  function renderImagePreviews(t) {
    var tEl = trackEl(modalEl(), t);
    if (!tEl) return;
    var imgs = imgsFor(t);
    var wrap = tEl.querySelector('[data-img-previews]');
    var count = tEl.querySelector('[data-img-count]');
    var upload = tEl.querySelector('[data-img-upload]');
    if (!wrap) return;
    wrap.innerHTML = '';
    imgs.forEach(function (im, i) {
      var d = document.createElement('div');
      d.className = 'img-thumb';
      var pic = document.createElement('img');
      pic.src = im.dataUrl;
      pic.alt = im.name;
      var x = document.createElement('button');
      x.type = 'button';
      x.className = 'img-thumb-remove';
      x.setAttribute('data-img-remove', '');
      x.dataset.index = i;
      x.setAttribute('aria-label', 'Remove image');
      x.textContent = '×';
      d.appendChild(pic);
      d.appendChild(x);
      wrap.appendChild(d);
    });
    if (count && upload) {
      count.textContent = imgs.length ? '(' + imgs.length + '/' + (upload.dataset.max || 3) + ')' : '';
    }
    if (imgs.length) {
      var errEl = tEl.querySelector('[data-img-error]');
      if (errEl) errEl.classList.remove('show');
    }
  }

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-img-input]');
    if (!input) return;
    var tEl = input.closest('[data-track]');
    if (!tEl) return;
    var t = tEl.dataset.track;
    var imgs = imgsFor(t);
    var upload = input.closest('[data-img-upload]');
    var max = parseInt((upload && upload.dataset.max) || '3', 10);
    var files = Array.prototype.slice.call(input.files || []);
    input.value = '';
    files.forEach(function (file) {
      if (imgs.length >= max) return;
      if (!/^image\//.test(file.type) && file.type !== '') return;
      processImageFile(file)
        .then(function (im) {
          if (imgs.length >= max) return;
          imgs.push(im);
          renderImagePreviews(t);
        })
        .catch(function () {
          alert('Could not add this image: too large or unsupported format.');
        });
    });
  });

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-img-remove]');
    if (!rm) return;
    var tEl = rm.closest('[data-track]');
    if (!tEl) return;
    imgsFor(tEl.dataset.track).splice(parseInt(rm.dataset.index, 10), 1);
    renderImagePreviews(tEl.dataset.track);
  });

  function resetTrack(t) {
    var tEl = trackEl(modalEl(), t);
    if (!tEl) return;
    var form = tEl.querySelector('form');
    if (form) form.reset();
    tEl.querySelectorAll('.sel').forEach(function (el) { el.classList.remove('sel'); });
    trackImgs[t] = [];
    renderImagePreviews(t);
  }

  function submitDesignForm(overlay) {
    var t = modalTrack;
    var tEl = trackEl(overlay, t);
    if (!tEl) return;
    var form = tEl.querySelector('form');
    var imgs = imgsFor(t);
    var errorBox = tEl.querySelector('[data-form-error]');
    collectSelections(tEl);
    var email = tEl.querySelector('[data-email]');
    if (email && (!email.value || !email.checkValidity())) {
      if (errorBox) errorBox.classList.add('show');
      email.focus();
      return;
    }

    /* Mandatory phone number */
    var phone = tEl.querySelector('[data-phone]');
    if (phone) {
      var phoneDigits = (phone.value || '').replace(/\D/g, '');
      var phoneErr = tEl.querySelector('[data-phone-error]');
      if (phoneDigits.length < 7) {
        if (phoneErr) phoneErr.classList.add('show');
        phone.focus();
        return;
      } else if (phoneErr) {
        phoneErr.classList.remove('show');
      }
    }

    /* Images: required or optional per track */
    var upload = tEl.querySelector('[data-img-upload]');
    if (upload && upload.dataset.required === 'true' && imgs.length === 0) {
      var imgErr = tEl.querySelector('[data-img-error]');
      if (imgErr) imgErr.classList.add('show');
      upload.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    var sheetUrl = (overlay.dataset.sheetUrl || '').trim();
    var sendEmail = overlay.dataset.sendEmail !== 'false';

    /* Email copy can't carry attachments — summarize them */
    var summary = tEl.querySelector('[data-img-summary]');
    if (summary) {
      summary.value = imgs.length
        ? imgs.length + ' image(s): ' + imgs.map(function (im) { return im.name; }).join(', ') + (sheetUrl ? ' (files in Google Drive, links in the sheet)' : '')
        : '';
    }

    var finalize = function () {
      if (!sheetUrl || sendEmail) {
        rememberTrack(t);
        form.submit(); /* Shopify contact form → store email; reload shows the stamp */
      } else {
        showDone();
        resetTrack(t);
      }
    };

    if (sheetUrl) {
      var payload = payloadFromForm(form);
      payload._form = t; /* routes the row to this track's tab; stripped by the connector */
      var hasImages = imgs.length > 0;
      if (hasImages) {
        payload.images = imgs.map(function (im) {
          return { name: im.name, type: im.type, data: im.dataUrl.split(',')[1] };
        });
      }
      var statusField = tEl.querySelector('[data-sheet-status]');

      var next = overlay.querySelector('[data-next]');
      if (next) {
        next.disabled = true;
        next.innerHTML = hasImages ? 'UPLOADING…' : 'SENDING…';
      }

      if (hasImages) {
        /* Can't use keepalive above ~64KB, so the page must not navigate
           until this settles. */
        window.addEventListener('beforeunload', warnBeforeUnload);
      }

      postToSheet(sheetUrl, payload, { keepalive: !hasImages, timeoutMs: hasImages ? 30000 : 8000 })
        .then(function (result) {
          if (hasImages) window.removeEventListener('beforeunload', warnBeforeUnload);
          if (statusField) statusField.value = result.state + (hasImages ? ' (with images)' : '');
          if (next) next.disabled = false;
          finalize();
        });
    } else {
      finalize();
    }
  }

  /* Theme editor: test the sheet connection without a full submission */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sheet-test]');
    if (!btn) return;
    var overlay = modalEl();
    var msg = document.querySelector('[data-sheet-test-msg]');
    var url = ((overlay && overlay.dataset.sheetUrl) || '').trim();
    if (!url) {
      if (msg) msg.textContent = 'Paste the webhook URL in this section\'s settings first.';
      return;
    }
    var t = btn.getAttribute('data-sheet-test') || 'livery';
    postToSheet(url, { 'Test': 'Theme editor connection test', '_form': t });
    if (msg) msg.textContent = 'Request sent. A row should appear in the Tests tab within a few seconds, with "' + t + '" in its Form column (that column only appears once the v5 connector is deployed). If nothing lands, open the /exec URL in a new tab: it must read "SHK connector OK v5.0", not a Google sign-in page or an older version.';
  });

  function checkModalFormState() {
    var overlay = modalEl();
    if (!overlay) return;
    if (overlay.querySelector('[data-form-success]')) {
      forgetTrack();
      openModal('done');
      if (!DESIGN && window.location.search) {
        history.replaceState(null, '', window.location.pathname);
      }
    } else if (overlay.querySelector('[data-form-failed]')) {
      var t = recallTrack();
      if (!trackEl(overlay, t)) t = firstTrack(overlay);
      openModal(t);
      goTrack(t, 'last');
      var tEl = trackEl(overlay, t);
      var errorBox = tEl && tEl.querySelector('[data-form-error]');
      if (errorBox) errorBox.classList.add('show');
    }
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open-modal]');
    if (opener) { openModal(opener.getAttribute('data-open-modal') || ''); return; }
    if (e.target.closest('[data-close-modal]')) { closeModal(); return; }
    var overlay = modalEl();
    if (!overlay || !overlay.classList.contains('open')) return;
    if (e.target === overlay) { closeModal(); return; }
    if (!overlay.contains(e.target)) return;
    var pick = e.target.closest('[data-pick-track]');
    if (pick) { goTrack(pick.dataset.pickTrack, 0); return; }
    if (e.target.closest('[data-back]')) {
      if (modalTrack && modalIdx > 0) goTrack(modalTrack, modalIdx - 1);
      else showPicker();
      return;
    }
    if (e.target.closest('[data-next]')) {
      if (!modalTrack) return;
      var steps = trackSteps(trackEl(overlay, modalTrack));
      if (modalIdx < steps.length - 1) goTrack(modalTrack, modalIdx + 1);
      else submitDesignForm(overlay);
      return;
    }
    var group = e.target.closest('[data-q]');
    if (group) {
      var o = e.target.closest('.opt,.sw');
      if (!o) return;
      if (o.classList.contains('sel')) { o.classList.remove('sel'); return; }
      var multi = +group.dataset.multi || 1;
      var sel = group.querySelectorAll('.sel');
      if (multi === 1) {
        sel.forEach(function (x) { x.classList.remove('sel'); });
      } else if (sel.length >= multi) {
        sel[0].classList.remove('sel');
      }
      o.classList.add('sel');
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeModal(); closeDrawer(); closeNav(); }
  });
  checkModalFormState();
  prefillCreatorInputs();
  syncPdpPropertyName();

  /* Theme editor support: re-check after re-render; preview modal while editing it */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('[data-design-overlay]')) {
      modalTrack = null;
      modalIdx = 0;
      trackImgs = {};
      checkModalFormState();
    }
  });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.querySelector('[data-design-overlay]')) openModal('');
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if (e.target.querySelector('[data-design-overlay]')) closeModal();
  });
  document.addEventListener('shopify:block:select', function (e) {
    var overlay = modalEl();
    if (!overlay || !overlay.contains(e.target)) return;
    var tEl = e.target.closest('[data-track]');
    if (!tEl) { openModal(''); return; }
    var stepEl = e.target.closest('.q-step');
    openModal(tEl.dataset.track);
    goTrack(tEl.dataset.track, stepEl ? trackSteps(tEl).indexOf(stepEl) : 0);
  });

  /* ================= CART DRAWER ================= */
  var drawerContainer = document.getElementById('CartDrawerContainer');
  var drawerOpen = false;

  function drawerRoot() {
    return drawerContainer ? drawerContainer.querySelector('[data-cart-drawer]') : null;
  }
  function openDrawer() {
    var root = drawerRoot();
    if (!root) return;
    drawerOpen = true;
    root.classList.remove('open');
    void root.offsetWidth; /* restart swoop */
    root.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    var root = drawerRoot();
    if (!root || !drawerOpen) return;
    drawerOpen = false;
    root.classList.remove('open');
    document.body.style.overflow = '';
  }
  function updateCartCount() {
    var root = drawerRoot();
    if (!root) return;
    var count = parseInt(root.dataset.count || '0', 10);
    document.querySelectorAll('[data-drawer-open]').forEach(function (link) {
      var badge = link.querySelector('[data-cart-count]');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'count';
          badge.setAttribute('data-cart-count', '');
          link.appendChild(badge);
        }
        badge.textContent = count;
      } else if (badge) {
        badge.remove();
      }
    });
  }
  function refreshDrawer(openAfter) {
    return fetch(routes.root + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        if (!drawerContainer) return;
        drawerContainer.innerHTML = html;
        updateCartCount();
        prefillCreatorInputs();
        if (openAfter || drawerOpen) openDrawer();
      });
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener && drawerRoot()) {
      e.preventDefault();
      openDrawer();
      return;
    }
    if (e.target.closest('[data-drawer-close]')) {
      closeDrawer();
    }
  });

  /* Quantity change / remove inside drawer */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-change-line]');
    if (!btn) return;
    var root = drawerRoot();
    if (root) root.setAttribute('aria-busy', 'true');
    fetch(routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        line: parseInt(btn.dataset.line, 10),
        quantity: parseInt(btn.dataset.quantity, 10)
      })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshDrawer(true); })
      .catch(function () { window.location.href = routes.cart; });
  });

  /* Giveaway gate: block checkout until the Instagram handle is saved */
  document.addEventListener('click', function (e) {
    var gated = e.target.closest('[data-gated]');
    if (gated) {
      e.preventDefault();
      var input = document.querySelector('[data-ig-input]');
      if (input) {
        input.focus();
        input.classList.add('shake');
        setTimeout(function () { input.classList.remove('shake'); }, 450);
      }
      return;
    }
    var save = e.target.closest('[data-ig-save]');
    if (!save) return;
    var igInput = document.querySelector('[data-ig-input]');
    var value = igInput ? igInput.value.trim() : '';
    if (!value) {
      if (igInput) {
        igInput.focus();
        igInput.classList.add('shake');
        setTimeout(function () { igInput.classList.remove('shake'); }, 450);
      }
      return;
    }
    save.disabled = true;
    fetch(routes.cartUpdate + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: { 'Instagram Handle': value } })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshDrawer(true); })
      .catch(function () { save.disabled = false; });
  });

  /* Creator code: entered right before CHECKOUT (drawer + cart page). If filled
     in, it's saved as a cart attribute (so it lands on the order for payout
     tracking) and the code is applied as a real discount via Shopify's
     /discount/{code} route before continuing to checkout. If the code doesn't
     match a live Shopify discount, Shopify silently ignores it and checkout
     proceeds as normal — there's no storefront way to validate a code without
     an app, so a typo won't show an error to the shopper. If the field is
     empty, checkout proceeds immediately with no extra request. */
  document.addEventListener('click', function (e) {
    var checkoutBtn = e.target.closest('[data-checkout-btn]');
    if (!checkoutBtn || checkoutBtn.hasAttribute('data-gated')) return;
    var scope = checkoutBtn.closest('.drawer-foot') || checkoutBtn.closest('form');
    var input = scope ? scope.querySelector('[data-creator-input]') : null;
    var code = input ? input.value.trim() : '';
    if (!code) return; /* nothing entered — let checkout proceed normally */
    e.preventDefault();
    checkoutBtn.disabled = true;
    fetch(routes.cartUpdate + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: { 'Creator Code': code } })
    })
      .catch(function () {})
      .then(function () {
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/checkout';
      });
  });

  /* Enter key inside the creator code input goes straight to checkout
     (preventing it from submitting the page-cart form as an UPDATE instead) */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var creatorInput = e.target.closest('[data-creator-input]');
    if (!creatorInput) return;
    e.preventDefault();
    var scope = creatorInput.closest('.drawer-foot') || creatorInput.closest('form');
    var btn = scope ? scope.querySelector('[data-checkout-btn]') : null;
    if (btn) btn.click();
  });

  /* Enter key inside the IG input saves the handle */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var igInput = e.target.closest('[data-ig-input]');
    if (!igInput) return;
    e.preventDefault();
    var save = document.querySelector('[data-ig-save]');
    if (save) save.click();
  });

  /* Theme editor: selecting the Cart Drawer section previews it open */
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.querySelector('[data-cart-drawer]')) openDrawer();
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if (e.target.querySelector('[data-cart-drawer]')) closeDrawer();
  });

  /* ================= AJAX ADD TO CART (delegated) ================= */
  var toast = document.querySelector('[data-toast]');
  var toastTimer;
  function showToast() {
    if (!toast) return;
    clearTimeout(toastTimer);
    toast.classList.add('show');
    toastTimer = setTimeout(function () { toast.classList.remove('show'); }, 2600);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    var isProduct = form.classList.contains('product-form') || form.classList.contains('quick-add-form');
    if (!isProduct || !form.querySelector('[name="id"]')) return;
    e.preventDefault();
    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;

    /* Never send blank optional line item properties (keeps orders clean) */
    var addBody = new FormData(form);
    if (String(addBody.get('properties[Creator Code]') || '').trim() === '') {
      addBody.delete('properties[Creator Code]');
    }

    fetch(routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: addBody
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (data) { throw data; });
        return r.json();
      })
      .then(function () {
        showToast();
        return refreshDrawer(true);
      })
      .catch(function (err) {
        alert((err && err.description) || 'Could not add to cart.');
      })
      .then(function () {
        if (submitBtn) submitBtn.disabled = false;
      });
  });

  /* ================= PRODUCT PAGE (delegated) ================= */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-thumb]');
    if (!btn) return;
    var media = btn.closest('[data-product-media]');
    var mainImg = media && media.querySelector('[data-main-image]');
    if (!mainImg) return;
    mainImg.src = btn.dataset.thumb;
    mainImg.removeAttribute('srcset');
    media.querySelectorAll('[data-thumb]').forEach(function (b) { b.classList.remove('sel'); });
    btn.classList.add('sel');
  });

  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-variant-select]');
    if (!select) return;
    var opt = select.selectedOptions[0];
    var priceEl = document.querySelector('[data-price]');
    var compareEl = document.querySelector('[data-compare]');
    var saleFlag = document.querySelector('[data-sale-flag]');
    var addBtn = document.querySelector('[data-add-to-cart]');
    var stickyAdd = document.querySelector('[data-sticky-add]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    if (priceEl) priceEl.textContent = opt.dataset.price;
    if (stickyPrice) stickyPrice.textContent = opt.dataset.price;
    if (compareEl) {
      var hasCompare = !!opt.dataset.compare;
      compareEl.textContent = opt.dataset.compare || '';
      compareEl.style.display = hasCompare ? '' : 'none';
      if (saleFlag) saleFlag.style.display = hasCompare ? '' : 'none';
    }
    var available = opt.dataset.available === 'true';
    [addBtn, stickyAdd].forEach(function (b) {
      if (!b) return;
      b.disabled = !available;
      b.innerHTML = available
        ? 'カートに入れる<small>ADD TO CART</small>'
        : '完売<small>SOLD OUT</small>';
    });
    var low = document.querySelector('[data-low-stock]');
    if (low) {
      var threshold = parseInt(low.dataset.threshold || '0', 10);
      var inv = opt.dataset.inventory === '' ? NaN : parseInt(opt.dataset.inventory, 10);
      if (threshold > 0 && !isNaN(inv) && inv > 0 && inv <= threshold) {
        low.querySelectorAll('[data-stock-count]').forEach(function (el) { el.textContent = inv; });
        low.style.display = '';
      } else {
        low.style.display = 'none';
      }
    }
  });

  /* Quantity stepper */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var wrap = (minus || plus).closest('.qty-stepper');
    var input = wrap && wrap.querySelector('input[name="quantity"]');
    if (!input) return;
    var v = parseInt(input.value || '1', 10);
    input.value = Math.max(1, v + (plus ? 1 : -1));
  });

  /* Sticky mobile buy bar → submit the real product form */
  document.addEventListener('click', function (e) {
    var stickyAdd = e.target.closest('[data-sticky-add]');
    if (!stickyAdd || stickyAdd.disabled) return;
    var form = document.querySelector('form.product-form');
    if (form) {
      if (form.requestSubmit) form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
  });

  /* ================= CART PAGE: remove line (delegated) ================= */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cart-sec [data-remove-line]');
    if (!btn) return;
    var line = btn.closest('.cart-line');
    var qty = line && line.querySelector('input[name="updates[]"]');
    var cartForm = btn.closest('form');
    if (qty && cartForm) {
      qty.value = 0;
      cartForm.submit();
    }
  });
})();
